module.exports = __webpack_public_path__ + "fonts/emj_skolkovo.63241f0.woff";